/*
  Tokyo Romance Club — STYLE COLLECTIONS scroll reveal.
  Heading, subheading and each of the 6 cards are observed independently
  via IntersectionObserver, so items only fade up once they individually
  enter the viewport (mobile only reveals cards as they scroll into view).
  Items that become visible together stagger by ~90ms. Once revealed, an
  element is unobserved and never re-hidden. Never runs inside the theme
  editor.
*/
(function () {
  if (window.__trcStyleCollectionsMotionInit) return;
  window.__trcStyleCollectionsMotionInit = true;

  var designMode = document.documentElement.classList.contains('shopify-design-mode');
  if (designMode) return;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var REVEAL_CLASS = 'trc-sc-in';
  var STAGGER_MS = 90;

  function reveal(el) {
    el.classList.add(REVEAL_CLASS);
  }

  function collectTargets(section) {
    var targets = [];
    var heading = section.querySelector('[class*="__heading"]');
    if (heading) targets.push(heading);
    var subheading = section.querySelector('[class*="__subheading"]');
    if (subheading) targets.push(subheading);
    section.querySelectorAll('.style-collection-card').forEach(function (card) {
      targets.push(card);
    });
    return targets;
  }

  function init() {
    var section = document.querySelector('[id$="__trc_japan_intl"]');
    if (!section) return;

    document.documentElement.classList.add('trc-js');

    var targets = collectTargets(section);
    if (targets.length === 0) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .forEach(function (entry, i) {
            io.unobserve(entry.target);
            window.setTimeout(function () {
              reveal(entry.target);
            }, i * STAGGER_MS);
          });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );

    targets.forEach(function (target) {
      io.observe(target);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
